"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ikeaSharedComponent = require("@ikea-aoa/ikea-shared-component");

var _ButtonEjs = _interopRequireDefault(require("./Button.ejs.js"));

require("./Button.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This component should be used for general buttons and it provides with general stylings according to NCL and fixes for common browsers and touch devices.
 *
 * @example
 * <ikea-component name="Button" data-label="Label of button"></ikea-component>
 * @example
 * <Button label="Label of button"></Button>
 */
var Button = /*#__PURE__*/function (_AbstractComponent) {
  _inherits(Button, _AbstractComponent);

  var _super = _createSuper(Button);

  /**
   * Class constructor.
   *
   * @param {Element} element The associated element.
   */
  function Button(element) {
    var _this;

    _classCallCheck(this, Button);

    _this = _super.call(this, element);
    _this._isHoverDisabled = false;
    _this._isPointerInteraction = false;
    _this._isPressAnimationComplete = false;
    _this._isTouch = false;
    _this._pressAnimationDuration = 300; // ms

    _this._timeout = null;
    return _this;
  }
  /**
   * Gets the template.
   *
   * @override
   * @returns {Function} Template parse function.
   */


  _createClass(Button, [{
    key: "getTemplate",
    value: function getTemplate() {
      return _ButtonEjs.default;
    }
    /**
     * Set keyboard-focus class on element.
     *
     * @param {HTMLElement} element Element to apply changes to.
     */

  }, {
    key: "_setKeyboardFocus",
    value: function _setKeyboardFocus(element) {
      element.classList.add('Button--keyboard-focus');
    }
    /**
     * Remove keyboard-focus class from element.
     *
     * @param {HTMLElement} element Element to apply changes to.
     */

  }, {
    key: "_removeKeyboardFocus",
    value: function _removeKeyboardFocus(element) {
      element.classList.remove('Button--keyboard-focus');
    }
    /**
     * Set press-feedback class on element.
     *
     * @param {HTMLElement} element Element to apply changes to.
     */

  }, {
    key: "_setPressFeedback",
    value: function _setPressFeedback(element) {
      var _this2 = this;

      clearTimeout(this._timeout);
      element.classList.add('Button--press-feedback');
      this.debounce(function () {
        _this2._isPressAnimationComplete = true;

        _this2._removePressFeedback(element);
      }, this._pressAnimationDuration);
    }
    /**
     * Remove press-feedback class from element.
     *
     * @param {HTMLElement} element Element to apply changes to.
     */

  }, {
    key: "_removePressFeedback",
    value: function _removePressFeedback(element) {
      if (this._isPressAnimationComplete && !this._isPointerInteraction) {
        this._isPressAnimationComplete = false;
        element.classList.remove('Button--press-feedback');

        if (this._isTouch && this._isHoverDisabled) {
          this._isHoverDisabled = false;
          element.classList.add('Button--prevent-hover');
        }
      }
    }
    /**
     * Handles button click.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "handleClick",
    value: function handleClick(event) {
      if (!this._isTouch) {
        var target = event.currentTarget;

        if (!this._isPointerInteraction) {
          this._setPressFeedback(target);
        }

        this._isPointerInteraction = false;

        this._removePressFeedback(target);
      }

      this.trigger('click', null);
    }
    /**
     * Handles button mouse down.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "handleMousedown",
    value: function handleMousedown(event) {
      if (this._isTouch) {
        return;
      }

      var target = event.currentTarget;
      this._isPointerInteraction = true;

      this._setPressFeedback(target);
    }
    /**
     * Handles button mouse out.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "handleMouseout",
    value: function handleMouseout(event) {
      if (this._isTouch) {
        return;
      }

      var target = event.currentTarget;
      this._isPointerInteraction = false;

      this._removeKeyboardFocus(target);
    }
    /**
     * Handles button focus.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      var target = event.currentTarget;

      if (!this._isPointerInteraction) {
        this._setKeyboardFocus(target);
      }
    }
    /**
     * Handles button blur.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      var target = event.currentTarget;

      this._removeKeyboardFocus(target);
    }
    /**
     * Handles on touch start.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "handleTouchstart",
    value: function handleTouchstart(event) {
      var _this3 = this;

      this._isTouch = true;
      var target = event.currentTarget;
      this._isPointerInteraction = true;

      this._setPressFeedback(target); // legacy code - use css: @media (hover: none) {}


      if (!this._isHoverDisabled) {
        this._isHoverDisabled = true;
        target.classList.remove('Button--prevent-hover');
        this.debounce(function () {
          _this3._isHoverDisabled = false;
          target.classList.add('Button--prevent-hover');
        }, 300);
      }
    }
    /**
     * Handles button touch end.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "handleTouchend",
    value: function handleTouchend(event) {
      var target = event.currentTarget;
      this._isPointerInteraction = false;

      this._removePressFeedback(target);
    }
    /**
     * Returns an array of supported events.
     *
     * @override
     * @summary
     * click: Triggered when button is clicked.
     * @returns {string[]} Supported event names. Example: ['click'].
     */

  }], [{
    key: "supportedEvents",
    get: function get() {
      return ['click'];
    }
    /**
     * Returns the supported props.
     *
     * @override
     * @summary
     * disabled: If set to true button is disabled
     * label: Text on button
     * layout: Appearance and function 'primary' or 'secondary'.
     * icon: Icon on button
     * alignIcon: Align the icon 'right' or 'left'.
     * @returns {SupportedProp[]} Supported prop objects.
     */

  }, {
    key: "supportedProps",
    get: function get() {
      return [new _ikeaSharedComponent.SupportedProp('layout', 'string', false, ['primary', 'secondary', 'text-only'], 'primary'), new _ikeaSharedComponent.SupportedProp('icon', 'string', false), new _ikeaSharedComponent.SupportedProp('alignIcon', 'string', false, ['left', 'right'], 'left'), new _ikeaSharedComponent.SupportedProp('label', 'string', false), new _ikeaSharedComponent.SupportedProp('disabled', 'boolean', false, null)];
    }
    /**
     * Returns the component name.
     *
     * @override
     * @returns {string} Component name.
     */

  }, {
    key: "componentName",
    get: function get() {
      return 'Button';
    }
  }]);

  return Button;
}(_ikeaSharedComponent.AbstractComponent);

exports.default = Button;